// extracted by mini-css-extract-plugin
export default {"container":"Tabs_container__2nQT0","tab":"Tabs_tab__jgCXc","active":"Tabs_active__oZ99m","count":"Tabs_count__1tMlW"};